"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
function CheckList(_a) {
    var conditions = _a.conditions, setConditions = _a.setConditions;
    var onToggleConfirm = function (id) {
        var newConditions = __spreadArray([], __read(conditions), false);
        var index = newConditions.findIndex(function (x) { return x.id === id; });
        newConditions[index].confirmed = !newConditions[index].confirmed;
        setConditions(newConditions);
    };
    var conditionsButtons = conditions.map(function (condition) { return (react_1.default.createElement("a", { key: condition.id, onClick: function () { return onToggleConfirm(condition.id); }, className: (0, clsx_1.default)({ checklistElement: true, checklistElementConfirmed: condition.confirmed }) },
        react_1.default.createElement("i", { className: "implioicons-check" }),
        condition.text)); });
    return react_1.default.createElement("div", { className: "checklist" }, conditionsButtons);
}
exports.default = CheckList;
